export class OOMenuItemNutritionalInformation {
	priceLevel: number;
	kilojoules: string;
	calories: string;
	servingSize: string;
	totalFat: OOMenuItemNutritionalInformationItem = new OOMenuItemNutritionalInformationItem();
	cholesterol: OOMenuItemNutritionalInformationItem = new OOMenuItemNutritionalInformationItem();
	sodium: OOMenuItemNutritionalInformationItem = new OOMenuItemNutritionalInformationItem();
	carbohydrates: OOMenuItemNutritionalInformationItem = new OOMenuItemNutritionalInformationItem();
	protein: OOMenuItemNutritionalInformationItem = new OOMenuItemNutritionalInformationItem();
	sugar: OOMenuItemNutritionalInformationItem = new OOMenuItemNutritionalInformationItem();
	allergens: string[] = [];

	public constructor(init?: Partial<OOMenuItemNutritionalInformation>) {
		Object.assign(this, init);
	}
}

export class OOMenuItemNutritionalInformationItem {
	value: number;
	uom: string;

	public constructor(init?: Partial<OOMenuItemNutritionalInformationItem>) {
		Object.assign(this, init);
	}
}
